import React from "react";
import { CourseResource } from "../../../../stores/CoursesStore/Types";

interface Props {
  courseResource: CourseResource;
}

const CourseBadge: React.FC<Props> = ({ courseResource }) => {
  if (courseResource.enrolled_student_present || courseResource.enrolment_id) {
    return <span className="badge enrolled">Enrolled</span>;
  }

  if (courseResource.content_version === "upcoming") {
    return <span className="badge coming">Coming Soon</span>;
  }

  if (courseResource.sample) {
    return <span className="badge free">Free Sample</span>;
  }

  // Ticked in admin for a course given a big update for the AI age. A choice
  // someone made, so it wins over New and Bestseller, which are worked out.
  if (courseResource.rebuilt_for_ai) {
    return <span className="badge rebuilt">Rebuilt for AI</span>;
  }

  if (courseResource.new_course || courseResource.went_live_in_the_past_month) {
    return <span className="badge new">New</span>;
  }

  if (courseResource.best_seller) {
    return <span className="badge bestseller">Bestseller</span>;
  }

  return null;
};

export default CourseBadge;
